// extracted by mini-css-extract-plugin
export default {"header":"RestoreRadabankPassword_header__mcaCz","content":"RestoreRadabankPassword_content__GPynq","icon":"RestoreRadabankPassword_icon__OHOzZ"};